import { ACTION_TYPES } from '../Constants';

export const openStartDropdown = () => ({
  type: ACTION_TYPES.START_DROPDOWN_OPENED,
});
export const closeStartDropdown = () => ({
  type: ACTION_TYPES.START_DROPDOWN_CLOSED,
});
export const openNavbar = () => ({
  type: ACTION_TYPES.NAVBAR_OPENED,
});
export const closeNavbar = () => ({
  type: ACTION_TYPES.NAVBAR_CLOSED,
});
export const setNavbarTab = tab => ({
  type: ACTION_TYPES.NAVBAR_TAB_CHANGED, tab,
});
export const toggleNavbarSpinner = loading => ({
  type: ACTION_TYPES.NAVBAR_SPINNER_TOGGLED, loading,
});
export const openCommuteModal = () => ({
  type: ACTION_TYPES.COMMUTE_MODAL_OPENED,
});
export const closeCommuteModal = () => ({
  type: ACTION_TYPES.COMMUTE_MODAL_CLOSED,
});

export const openFeedbackModal = () => ({
  type: ACTION_TYPES.FEEDBACK_MODAL_OPENED,
});
export const closeFeedbackModal = () => ({
  type: ACTION_TYPES.FEEDBACK_MODAL_CLOSED,
});

export const toggleMapLayer = () => ({
  type: ACTION_TYPES.TOGGLE_MAP_LAYER,
});
export const toggleHamburgerMenu = visible => ({
  type: ACTION_TYPES.TOGGLE_HAMBURGER_MENU, visible,
});
export const setContactNotification = state => ({
  type: ACTION_TYPES.TOGGLE_CONTACT_NOTIFICATION, state,
});
export const toggleFilterState = filterToggles => ({
  type: ACTION_TYPES.TOGGLE_FILTER_STATE, filterToggles,
});
export const toggleFilterExpanded = expandToggles => ({
  type: ACTION_TYPES.TOGGLE_FILTER_EXPANDED, expandToggles,
});
export const changeFavSortOption = sortOption => ({
  type: ACTION_TYPES.CHANGE_FAV_SORT_OPTION, sortOption,
});
export const toggleGotCommuteForAreas = flag => ({
  type: ACTION_TYPES.TOGGLE_GOT_COMMUTE_FOR_AREAS, flag,
});



// WEBPACK FOOTER //
// ./src/Actions/ToggleActions.js